import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6384ecea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "404", -1))
const _hoisted_4 = { class: "action__block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SignUpDialog = _resolveComponent("SignUpDialog")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      onLogin: _ctx.onClickLogin,
      onReg: _ctx.onClickReg
    }, null, 8, ["onLogin", "onReg"]),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('pages.notFound.title')), 1),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pages.notFound.subTitle')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
            centered: "",
            text: "Homepage"
          }),
          _createVNode(_component_Button, {
            onClick: _ctx.onClickReg,
            centered: "",
            outlined: "",
            text: "Join"
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _createVNode(_component_SignUpDialog, {
      open: _ctx.showRegDialog,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRegDialog = false))
    }, null, 8, ["open"]),
    _createVNode(_component_LoginDialog, {
      open: _ctx.showLoginDialog,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showLoginDialog = false))
    }, null, 8, ["open"])
  ]))
}